<div class="modal-container">
    <div class="modal-header">
        <div class="modal-title">
            {{title}}
        </div>
        <button class="modal-close-button" (click)="onCloseButtonClick()">
            <img src="" class="closeIcon" />
        </button>
    </div>
    <div class="modal-body">
        <ng-content></ng-content>
    </div>
</div>
